<template>
    <Head title="Card Details" />
    <CardDetailComponent :id="cardId" />
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import CardDetailComponent from '@/components/next-card/card-detail.vue';

// Props recibidas del controller
const props = defineProps({
    cardId: {
        type: [String, Number],
        required: true
    }
});
</script>
